<template>
    <article class="accordion is-active">
      <div class="accordion-header">
        <h3 class="is-size-5 has-text-weight-bold">Checkout <img src="@/assets/img/yup.png"/></h3>
      </div>
      <div class="accordion-body">
        <div class="accordion-content">
          <div class="checkout-accordion-content-wrap">
            <h3 class="accordion-title is-size-5 has-text-weight-bold">Checkout</h3>
            <div class="checkout-accordion-content">
              <!-- Order type -->

              <div v-if="vg_selectedStore.currently_open && enablePickup">
                
                    <div class="review-order-type-wrapper kiosk-ordertype">
                        <h3 class="is-size-5 has-text-weight-semibold mb10">Order Type:</h3>
                        <div class="review-order-type-content">
                        <div class="review-order-type-left">
                            <p class="has-text-weight-bold is-size-14 is-capitalized">{{ this.vg_checkoutOrderType.order_receive_method }}</p>
                        </div>
                        <div class="review-order-type-right">
                            <p class="has-text-weight-bold is-size-14">{{ this.vg_checkoutOrderType.pickupTime }}</p>
                        </div>
                        </div>
                        <div class="review-order-type-content">
                        <div class="review-order-type-left">
                            <location-selected :headingclass="''"/>
                        </div>
                        <div class="review-order-type-right">
                            <p class="is-size-14">{{ this.vg_checkoutOrderType.delivery.address1 }}</p>
                        </div>
                        </div>
                    </div>
        
                    <!-- Payment -->
                    <div class="review-order-type-wrapper border-none mt0">
                        <h3 class="is-size-5 has-text-weight-semibold mb10">Payment:</h3>
                        <div class="review-order-type-content">
                        <div class="review-order-type-left">
                            <p class="is-size-14">Pay at store</p>
                        </div>
                        </div>
                    </div>
    
    
                    <!-- <div class="review-order-type-wrapper mb20 mt0" v-if="!this.vg_userId">
                        <h3 class="is-size-5 has-text-weight-semibold mb10">Captcha:</h3>
                        <div class="review-order-type-content review-captcha-wrap">
    
                            <vue-recaptcha ref="recaptcha"
                            :loadRecaptchaScript="true"
                                @verify="onVerify" @expired="expiredCaptcha" sitekey="6LenodUmAAAAAC3kPGJv4CYlsnBgIFNqjBWlVYzQ">
                            </vue-recaptcha>
                    
                        </div>
                    </div> -->
                    
                    <!-- <p class="text-primary" v-if="vg_loyalityPointsNotice" v-html="vg_loyalityPointsNotice"></p> -->
    
                    <div class="accordion-action mt20 accordion-flex-action">
                        <p>By submitting an order, you agree to the Budler <router-link class="hover-text-primary" target="_blank" :to="{ name: 'TermsConditions', params: { business_slug: $route.params.business_slug }, query: $route.query }">Terms of Use</router-link> and <router-link class="hover-text-primary" target="_blank" :to="{ name: 'PrivacyPolicy', params: { business_slug: $route.params.business_slug }, query: $route.query }">Privacy Policy</router-link></p>
                        <a
                        @click.prevent="submitOrder()"
                        href="#"
                        class="button bg-secondary btn-complete hover-opacity-7 text-white"
                        >
                        SUBMIT ORDER
                        </a>
                    </div>
                </div>
                <div v-else>
                    <p  class="has-text-danger">Sorry currenty pickup is not available.</p>
                </div>
            </div>
          </div>
        </div>
      </div>
    </article>
  </template>
  
  
  <script>
  import CartApis from '@/Components/Controllers/CartApis';
  import { mapGetters, mapActions, mapMutations } from "vuex";
  import Helpers from '@/Components/Helpers/Helpers';
  import LocationSelected from '@/Components/Pages/Inc/SelectedLocation';
  import moment from 'moment';
  import ProductApis from '@/Components/Controllers/ProductApis';
  import CheckoutApis from '@/Components/Controllers/CheckoutApis';
  import VboutApis from '@/Components/Controllers/VboutApis';
  import OrderHistoryApis from '@/Components/Controllers/OrderHistoryApis';
  import UserApis from '@/Components/Controllers/UserApis';

  
  export default {
    name: 'CheckoutKiosk',
    components: {
      LocationSelected,
    },
    data() {
      return {
        orderConfirmDetail: {},
        // captchaCanvas: ['can1', 'can2', 'can3', 'can4'],
        // captchCode: '',
        // confirmCaptchCode: '',
        // captchaVerified: false,
      };
    },
    computed: {
       
      ...mapGetters({
        vg_cartId: "cart/id",
        vg_userId: "getLoggedInUserId",
        vg_businessprofile: "businessprofile/detail",
        vg_cartItems: "cart/cartItems",
        vg_selectedStore: "location/selected",
        vg_cartSubTotal: "cart/cartSubTotal",
        vg_newSubTotal: "cart/newSubTotal",
        vg_is_greenline_pos: "location/is_greenline_pos",
        vg_greenlineProductDeposit: "cart/greenline_product_deposit",
        vg_cartTax: "cart/cartTax",
        vg_cartPromoCode: "cart/promocode",
        vg_is_tendy_pos: "location/is_tendy_pos",
        vg_cartGrandTotal: "cart/cartGrandTotal",
        vg_weightOnCart: "cart/cartWeight",
        vg_cannabisLimit: "location/cannabis_limit",
        vg_guestLandedQueries: "location/guestLandedQueries",
        vg_checkoutOrderType: "checkout/ordertype",
        vg_checkoutPayment: "checkout/payment",
        vg_cartLoyality: "cart/loyality",
        vg_hasBusinessLoyalityProgram: "businessprofile/hasBusinessLoyalityProgram",
        vg_userLoyalitySubscription: "userloyalitysubscription/subscribed",
        vg_cartLoyalityPointsObj: "cart/loyalityPointsObj",
        vg_loyalityPointsNotice: "cart/loyalityPointsNotice",
      }),

      enablePickup() {
        return this.vg_selectedStore.settings.pickup_orders ? this.vg_selectedStore.settings.pickup_orders.is_enabled && this.vg_selectedStore.settings.pickup_orders.is_active : false
     },
      

    },
    mounted() {
  
    },
    
    methods: {
     
      /**
       * Submit order
       */
      async submitOrder() {
  
  
        if( parseFloat(this.vg_weightOnCart) > parseFloat(this.vg_cannabisLimit) ){
          bus.$emit('show-modal-cart-limit-exceed', {
            overWeight: this.vg_weightOnCart,
            modal: true,
          });
          return false;
        }
  
        // if( !this.vg_userId && !this.captchaVerified)  {
        //   return this.va_snackbar({
        //     type: "warning",
        //     message: 'Please verify captcha.',
        //   });
        // }
  
        this.va_spinner(true)
        // First check the unavailable item on cart
        let unavailableVariants = await this.checkUnavailaleItemsOfCartitems();
      
        if(unavailableVariants.modal){
          this.va_spinner(false)
          // there are some unavailable variants/ products please stop with alert
          return bus.$emit('item-no-longer-onstock', {
            modal: true,
            message: unavailableVariants.message,
          });
        }
  
        // Everything is good, lets create checout obj
        let pickuptime = '';
        // we get sometime blank pickup time 
        
        // If pickup is balnk but store is open 
        
        // Add 30minutes on current time
        pickuptime = Helpers.storeNowAddedTime(this.vg_selectedStore, 15);
        
        //Prevent sending invalid time , convert to UTC
        let utcTime;
        if(pickuptime){
          moment.tz.setDefault( (this.vg_selectedStore.address && this.vg_selectedStore.address.timezone_id) ? this.vg_selectedStore.address.timezone_id : 'America/Toronto');
          let convertTime = moment(pickuptime, "YYYY-MM-DD hh:mm a").tz(this.vg_selectedStore.address && this.vg_selectedStore.address.timezone_id ? this.vg_selectedStore.address.timezone_id : 'America/Toronto');
          utcTime = convertTime.utc().format('YYYY-MM-DD HH:mm:ss');
        } else {
          utcTime = '';
        }
        
        let obj = {
          cartId: this.vg_cartId,
          receive_time: utcTime,
          pay_later:  true,
          order_receive_method: 'pickup',
          user: {
            first_name: 'kiosk',
            last_name: 'kiosk',
            email: 'kiosk@mybusiness.com',
            phone:  '0123456789'
          },
          note: '',
        };
     
        this.va_spinner(true)
        let res = await CheckoutApis.checkout(obj);
        if (res.status == 200) {
          this.orderConfirmDetail = res.data.payload;
          // G tracking purchased item
          this.$gtag.event('purchase', { 
            transaction_id: this.orderConfirmDetail.id,
            order_id: this.orderConfirmDetail.id,
            affiliation: this.orderConfirmDetail.location_id,
            value: this.orderConfirmDetail.total ? this.orderConfirmDetail.total.toFixed(2) : this.vg_checkoutOrderType.grandTotal.toFixed(2), // this is from frontend not api
            currency: "CAD",
            tax: this.orderConfirmDetail.tax ? this.orderConfirmDetail.tax : 0,
            shipping: this.vg_checkoutOrderType.delivery_fee ? this.vg_checkoutOrderType.delivery_fee  : 0,
            items: Helpers.GTagKeyValueForChekout(this.vg_cartItems),
          });
        
          // pushed to vbout 
          if(this.$store.getters.getLoggedInUserToken){
            VboutApis.createOrder(res.data.payload, this.vg_selectedStore.id)
          }
          this.va_setCartDetail({}); // double protect
          this.va_setCartId('');
          this.va_setCartItems([]);
          // If user is logged in fetch recent orders
          if (this.$store.getters.getLoggedInUserToken) {
            let orderRes = await OrderHistoryApis.fetch(1); // page 1
            if (orderRes.status == 200) {
              this.va_setAllOrders(orderRes.data.payload);
            }
          }
          this.va_resetCheckoutData();
          this.va_setSuccessObj(res.data.payload);
          // If user has change his details then update
          if(this.$store.getters.getLoggedInUserToken){
            let userDetailRes  = await UserApis.fetchUserDetail();
            if(userDetailRes.status == 200){
              // On checkout we can only update fname and lname so lets update values
              this.vm_mutateUserDetailByKeys({
                first_name: userDetailRes.data.payload.first_name,
                last_name: userDetailRes.data.payload.last_name,
                marketing_notification: userDetailRes.data.payload.marketing_notification,
              })
            }
          }
          this.va_spinner(false)
  
          // Push to success page
          this.$router.push({ 
            name: 'CartSuccess',
            params: {
              store_slug: this.$route.params.store_slug,
              business_slug: this.$route.params.business_slug,
            },
            query: {...this.$route.query, ...{ order_id: res.data.payload.id }}
          })
        } else if(res.response && (res.response.status == 500) ) {
          this.va_spinner(false)
          this.va_snackbar({
            type: "warning",
            message: res.response.data.msg,
          });
        } else {
          this.va_spinner(false)
          let errMessage = "Error placing order."; // We get message on different keys
          if(res.response.data){
            errMessage = Helpers.catchErrorMessage(res.response.data);
          } 
          this.va_snackbar({
            type: "warning",
            message: errMessage,
          });
        }
      },
  
      /**
       * Check availablility of product on stock
       */
      async checkUnavailaleItemsOfCartitems() {
        // Collect Location variant ids to pass on api to check its latest availability
        let cartItemVariantIds = _.map(this.vg_cartItems, 'location_product_variant_id');
        let checkVariantsAvailability = await ProductApis.getProductVaraintByIds(cartItemVariantIds);
        if(checkVariantsAvailability.status != 200){
          console.log('failed to check availability of variants.')
          return {
            modal: false,
            message: null,
          };  
        }
        // On success, filter and collect variants whose inventory is less than out of stock or availability false 
        let unavailableVariants = _.filter(checkVariantsAvailability.data.payload, function(o) { 
                                    return o.no_of_units <= o.inventory_threshold || o.available == false || o.discontinued == true
                                  }); 
        // If there is any variants which match the reject logic
        if(unavailableVariants.length > 0){
          // Create message
         let message = 'Unfortunately the following <br/>';
          message +=  unavailableVariants.length > 1 ? 'products are no longer in stock.<br/>' : 'product is no longer in stock.<br/>';
          // foreach all variant who pass the reject logic
          unavailableVariants.forEach( async(item) => {
            let hasUnavailableVariant = _.find(this.vg_cartItems, { location_product_variant_id: item.id });
            // match the variant id on cart item to delete
            if(hasUnavailableVariant != undefined){
              // store product name size
              message += '<br/> ' + item.name;
              message += item.size ? ' Size: ' + item.size : '';
              // delete item from cart
              await CartApis.delete({
                cart_product_id: hasUnavailableVariant.id, // mean the cart service product id which is aaded per variant
                location_id: this.$store.getters['location/selected'].id ? this.$store.getters['location/selected'].id : '',
              });
            }
          })
          return {
            modal: true,
            message: message,
          }; 
        } 
  
        return {
          modal: false,
          message: null,
        }; 
  
      },
  
      
      ...mapMutations({
        vm_mutateUserDetailByKeys: "MUTATE_USER_DETAILS_BY_KEYS",
      }),
  
    
      // onVerify: function (response) {
      //   this.captchaVerified = true;
      // },
      // expiredCaptcha: function(err) {
      //   this.captchaVerified = false;
      // },
  
      ...mapActions({
        va_spinner: "spinner/setSpinner",
        va_snackbar: "snackbar/setSnackbar",
        va_setCartItems: "cart/setCartItems",
        va_setCartDetail: "cart/setCartDetail",
        va_setCartId: "cart/setId",
        va_setAllOrders: "orderhistory/setAllOrders",
        va_setSuccessObj: 'cart/setSuccessObj',
        va_resetCheckoutData: 'checkout/resetCheckoutData'
      })
  
    },
  };
  </script>
  
  
  